/* eslint-disable vue/custom-event-name-casing */
import getAnalyticsEventBus from '../common/getAnalyticsEventBus';
import { assignUpidToProduct } from '../common/helpers/productModelHelpers';
import App from './components/App.vue';
import EventBusConfig from './config/eventBusConfig';
import router from './router';
import store, { getters, types } from './store';
import { Vue, EventBus } from './vue';

const componentsForms = require('../components/forms');
const componentsClientSideValidation = require('../components/clientSideValidation');
const domUtils = require('../common/utils/dom');

const analyticsEventBus = getAnalyticsEventBus();
const { PRODUCT_TILE_LOCATION } = require('../../../../config/analytics');

const {
  clickedItemListStorage,
  impressionItemListStorage,
  createItemListAndPosition,
} = require('../analytics/stores/itemList');

const { searchDataStorage } = require('../analytics/stores/searchData');
const { oneBasedPosition } = require('../analytics/ga4/utils/positionUtils');

/**
 * Update page meta datas (title, description) with page properties
 * that SFRA adds.
 * @param {Object} pageObject SFRA product or category
 */
function updatePageMetas(pageObject = {}) {
  window.document.title = pageObject?.pageTitle || '';
  domUtils.setMeta('description', pageObject?.pageDescription || '');
}

/**
 * Initializing vueApp when needed.
 */
function initVueApp() {
  const vueApp = document.getElementById('vue-app');
  // If it is not found, then abort the creation of Vue instance
  // Example: Login page
  if (!vueApp) return;

  const data = JSON.parse(vueApp.dataset.vue);

  if (data?.TheProductList) {
    store.dispatch(types.productList.init, {
      productSearch: data.TheProductList,
      url: window.location,
    });
  }

  if (data?.TheProductDetails) {
    store.commit(types.product.update, {
      ...data.TheProductDetails,
    });
  }

  if (data?.TheProductCustomizer) {
    store.dispatch(types.productCustomizer.load, data.TheProductCustomizer);
  }

  if (data?.Account) {
    store.commit(types.account.init, data.Account);
  }

  if (data?.Cart) {
    store.dispatch(types.cart.init, data.Cart);
  }
  // eslint-disable-next-line no-unused-vars
  const vm = new Vue({
    el: '#vue-app',
    components: {
      App,
    },
    render(h) {
      return h(App);
    },
    store,
    router,
  });
}

// -------------------------------------------------------------------------
//  EventBus listeners & commands
// -------------------------------------------------------------------------

//
//  General related listeners
// -------------------------------------------------------------------------
EventBus.$on('header-popup:hide', () => {
  $('body').trigger('header-popup:hide');
});

EventBus.$on(EventBusConfig.events.router.willNavigate, ({ from, to }) => {
  analyticsEventBus.publish(
    analyticsEventBus.EVENTS.userWillNavigateDinamically,
    {
      from,
      to,
    }
  );
});

EventBus.$on(
  EventBusConfig.events.pageTitleLoaded,
  ({ pageTitle, pageType }) => {
    analyticsEventBus.publish(analyticsEventBus.EVENTS.pageLoadedDynamically, {
      pageTitle,
      pageType,
    });
  }
);

//
//  BaseProductTileQuickShop related listeners
// -------------------------------------------------------------------------
// eslint-disable-next-line listeners/no-inline-function-event-listener, listeners/no-missing-remove-event-listener
$('body').on(
  'quickShop:afterAddSizeToCart',
  /**
   * Trigger EventBus event after adding size to cart
   * @param {jQuery.Event} e jQuery Event
   * @param {Object} payload Event payload
   * @param {Object} payload.productVariation attributeSelect() response
   * @param {FullProduct} payload.productVariation.product attributeSelect() product
   * @param {Object} payload.productVariation.resources Useful messages
   * @param {Object} payload.cartAddProduct Cart-AddProduct response
   * @param {Cart} payload.cartAddProduct.cart Cart model
   * @param {FullProduct} payload.cartAddProduct.product Variant full product
   * @param {string} payload.cartAddProduct.pliUUID UUID of the added line item
   */
  (e, { productVariation, cartAddProduct }) => {
    assignUpidToProduct(productVariation?.product);
    EventBus.$emit(EventBusConfig.events.BaseProductTileQuickShop.addedToCart, {
      productVariation,
      cartAddProduct,
    });
  }
);

//
//  TheProductDetails related listeners
// -------------------------------------------------------------------------
EventBus.$on(EventBusConfig.events.TheProductDetails.loaded, (product) => {
  updatePageMetas(product);

  // Dispatch product view event for Analytics
  analyticsEventBus.publish(analyticsEventBus.EVENTS.productDetailsViewed, {
    product,
  });
});

// eslint-disable-next-line listeners/no-inline-function-event-listener, listeners/no-missing-remove-event-listener
$('.header .search').on('click', (event) => {
  event.preventDefault();
  EventBus.$emit(EventBusConfig.commands.TheSearch.toggle);
});

EventBus.$on(
  EventBusConfig.events.TheProductDetails.zoomOpened,
  (zoomRequirements) => {
    $('body').trigger('the-product-details:image-zoom', zoomRequirements);
  }
);

EventBus.$on(EventBusConfig.events.TheProductDetails.zoomClosed, () => {
  $('body').trigger('the-product-details:after-image-zoom-close');
});

EventBus.$on(
  EventBusConfig.events.TheProductDetails.colorSelected,
  (color, container) => {
    $('body').trigger('product:selectColor', {
      color,
      container: $(container),
    });
  }
);

//
// BaseWishlistHeart related listeners
// -------------------------------------------------------------------------
EventBus.$on('wishlist-heart:clicked', (button, product) => {
  $('body').trigger('wishlist-heart:clicked', { button, product });
});

// eslint-disable-next-line listeners/no-inline-function-event-listener, listeners/no-missing-remove-event-listener
$('body').on('wishlist-heart:updated', (e, result) => {
  EventBus.$emit('wishlist-heart:updated', result);
});

// eslint-disable-next-line listeners/no-inline-function-event-listener, listeners/no-missing-remove-event-listener
$('body').on('wishlist-heart:update-from-cart', (e, data) => {
  EventBus.$emit(
    'wishlist-heart:update-from-cart',
    data.productId,
    data.variationGroupId
  );
});

//
// BaseProductSlider related listeners
// -------------------------------------------------------------------------
EventBus.$on(
  EventBusConfig.events.BaseProductSlider.ready,
  ({ products, tileContext }) => {
    analyticsEventBus.publish(analyticsEventBus.EVENTS.productSliderReady, {
      products,
      tileContext,
    });
  }
);

EventBus.$on(
  EventBusConfig.events.BaseProductSlider.updated,
  ({ products, tileContext }) => {
    analyticsEventBus.publish(analyticsEventBus.EVENTS.productSliderUpdated, {
      tileContext,
      products,
    });
  }
);

//
//  TheProductList related listeners
// -------------------------------------------------------------------------
EventBus.$on(
  EventBusConfig.events.TheProductList.categoryChanged,
  (category) => {
    updatePageMetas(category);
  }
);

EventBus.$on(EventBusConfig.events.TheProductList.columnModeChanged, () => {
  window.scrollTo(0, 0);
});

//
//  TheSearch related listeners
// -------------------------------------------------------------------------
const header = document.querySelector('#byl-header');
const headerOpenedSearchClass = 'header--search-open';
EventBus.$on(EventBusConfig.events.TheSearch.hidden, () => {
  header.classList.remove(headerOpenedSearchClass);
  analyticsEventBus.publish(analyticsEventBus.EVENTS.searchHidden);
});
EventBus.$on(EventBusConfig.events.TheSearch.shown, () => {
  header.classList.add(headerOpenedSearchClass);
  // Send info to Analytics
  analyticsEventBus.publish(analyticsEventBus.EVENTS.searchShown);
  // Dispatch search engine session event for GA4
  analyticsEventBus.publish(
    analyticsEventBus.EVENTS.searchSessionUsed,
    gaInfo.searchEngineType
  );
});
EventBus.$on(EventBusConfig.events.TheSearch.toggled, () => {
  header.classList.toggle(headerOpenedSearchClass);
});
EventBus.$on(EventBusConfig.events.TheSearch.searched, (payload) => {
  // Insert query in search input
  analyticsEventBus.publish(
    analyticsEventBus.EVENTS.searchQueryInserted,
    payload
  );

  // Search results (or not) after launching the query
  if (payload.search.count > 0) {
    analyticsEventBus.publish(
      analyticsEventBus.EVENTS.searchReturnedResults,
      payload
    );
  } else {
    analyticsEventBus.publish(
      analyticsEventBus.EVENTS.searchReturnedNoResults,
      {
        query: payload.search.query,
        match: payload.search.match,
        isCached: payload.search.isCached,
      }
    );
  }
});

//
// BaseRMAStoreLocator listeners
// -------------------------------------------------------------------------
// eslint-disable-next-line listeners/no-missing-remove-event-listener
$('body').on('change', '.select-store-input', (e) => {
  const { storeInfo } = e.target.dataset;
  EventBus.$emit('base-rma-store-locator:select-store', {
    storeInfo,
  });
});

//
//  Vuex related
// -------------------------------------------------------------------------
EventBus.$on('product:color-updated', (productVariation) => {
  // When changing the color in PDP, the data is requested by a listener of
  // SFRA, not by router. So, url has to be updated.
  //
  // Update by means of History API to avoid unnecessary requests. Router is
  // not recommended because it will dispatch the loading of the full product
  // associated with the pid of this variation.
  const newUrl = productVariation.selectedProductUrl.split('?')[0];
  window.history.pushState(null, productVariation.pageTitle, newUrl);
});

//
//  SFRA Integration
// -------------------------------------------------------------------------
// eslint-disable-next-line listeners/no-inline-function-event-listener, listeners/no-missing-remove-event-listener
$('body').on('product:afterAttributeSelect', (e, payload) => {
  const productVariation = payload.data.product;
  const container = payload.container.get(0);
  assignUpidToProduct(productVariation);
  EventBus.$emit(EventBusConfig.commands.TheProductDetails.updateProduct, {
    product: productVariation,
    container,
  });
});
$('body').on(
  'product:afterAddToCart',
  /**
   *
   * @param {Event} e Event
   * @param {Object} data Cart-AddProduct response
   * @param {Cart} data.cart Cart model
   * @param {FullProduct} data.product Variant full product
   * @param {string} data.pliUUID UUID of the added line item
   */
  (e, data) => {
    const item = data.cart.items?.find((i) => i.UUID === data.pliUUID);
    if (item) {
      store.commit(types.cart.addItem, item);
    }
  }
);

// eslint-disable-next-line listeners/no-inline-function-event-listener, listeners/no-missing-remove-event-listener
$('body').on(
  'storeCart:updateItem',
  /**
   * Trigger update item quantity command
   * @param {jQuery.Event} e - Event
   * @param {Object} payload - Cart
   * @param {Cart} payload.cart - Cart
   * @param {UUID} payload.UUID - UUID of the updated line item
   * @returns {void}
   */
  (e, payload) => {
    const item = payload.cart.items?.find((i) => i.UUID === payload.UUID);
    store.commit(types.cart.updateItem, item);
  }
);

// eslint-disable-next-line listeners/no-inline-function-event-listener, listeners/no-missing-remove-event-listener
$('body').on(
  'storeCart:removeItem',
  /** storeCart:removeItem event handler
   * @param {jQuery.Event} e - Event object
   * @param {string} variantId - Removed line item ID (variant ID)
   */
  (e, variantId) => {
    store.commit(types.cart.removeItem, variantId);
    EventBus.$emit(
      EventBusConfig.events.BaseProductTileQuickShop.removedFromCart,
      variantId
    );
  }
);

EventBus.$on(
  EventBusConfig.commands.cart.removeAllSizesOfProduct,
  /**
   * Handle remove product command
   * @param {string} variationGroupId - Unique identifier assigned to this group
   */
  (variationGroupId) => {
    const getProductLineItems =
      store.getters[getters.cart.getProductLineItemsForVariationGroupId]; // eslint-disable-line import/no-named-as-default-member
    const removeProductLineItemUrl =
      store.getters[getters.cart.removeProductLineItemUrl]; // eslint-disable-line import/no-named-as-default-member
    const productLineItems = getProductLineItems(variationGroupId);
    productLineItems.forEach((productLineItem) =>
      $('body').trigger('cart:removeProductLineItem', {
        removeProductLineItemUrl,
        productLineItem,
      })
    );
  }
);

EventBus.$on(
  'cart:updateProductQty',
  ({ updateQuantityUrl, productID, quantity, UUID }) =>
    $('body').trigger('cart:updateProductQty', {
      updateQuantityUrl,
      productID,
      quantity,
      UUID,
    })
);

EventBus.$on('forms:init', () => {
  componentsForms.init();
  componentsClientSideValidation.init();
});

EventBus.$on('forms:validation', (form, playload) => {
  const formValidation = require('../components/formValidation');
  formValidation(form, playload);
});

// reset size selector
// eslint-disable-next-line listeners/no-inline-function-event-listener, listeners/no-missing-remove-event-listener
$('body').on('product:afterAddToCart', () => {
  EventBus.$emit(EventBusConfig.events.TheProductDetails.addedToCart);
  // lock changes on size-selector
  EventBus.$emit(EventBusConfig.commands.TheProductDetails.lookSizeSelector);

  setTimeout(() => {
    EventBus.$emit(EventBusConfig.commands.TheProductDetails.resetSizeSelector);
    // reset sfra size selector
    const $sfraSizeSelector = document.querySelector('.select-size');
    if ($sfraSizeSelector) $sfraSizeSelector.selectedIndex = -1;
  }, 1000);
});

//
//  RECOMMENDED PRODUCTS COMPONENT FROM SEARCH MODAL
// -------------------------------------------------------------------------
/**
 * Recommended product from search modal component is viewed event
 * @param {Object} payload The payload of the event
 * @param {Object} payload.product Data related to product
 * @param {String} payload.product.pid Product SKU
 * @param {Number} payload.index Product position in carousel
 * @param {string} payload.componentType The type of component
 */
EventBus.$on(
  EventBusConfig.events.TheSearchModal.recommendedProductViewed,
  (payload) => {
    const productId = payload.product.pid;
    const location = PRODUCT_TILE_LOCATION.search;
    const position = oneBasedPosition(payload.index);

    impressionItemListStorage.setItem(
      productId,
      createItemListAndPosition(location, position)
    );

    analyticsEventBus.publish(
      analyticsEventBus.EVENTS.searchRecommendedProductViewed,
      {
        productId,
        position,
        location,
        componentType: payload.componentType,
      }
    );
  }
);

/**
 * Recommended product from search modal component is clicked event
 * @param {Object} payload The payload of the event
 * @param {Object} payload.product Data related to product
 * @param {String} payload.product.pid Product SKU
 * @param {Number} payload.index Product position in carousel
 * @param {string} payload.componentType The type of component
 */
EventBus.$on(
  EventBusConfig.events.TheSearchModal.recommendedProductClicked,
  (payload) => {
    const productId = payload.product.pid;
    const location = PRODUCT_TILE_LOCATION.search;
    const position = oneBasedPosition(payload.index);

    clickedItemListStorage.setItem(
      productId,
      createItemListAndPosition(location, position)
    );

    searchDataStorage.setItem(productId, {
      count: undefined,
      match: location,
      query: undefined,
    });

    analyticsEventBus.publish(
      analyticsEventBus.EVENTS.searchRecommendedProductClicked,
      {
        productId,
        position,
        location,
        componentType: payload.componentType,
      }
    );
  }
);

export default initVueApp;
